import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LookupModalService {
  lookupModal = new EventEmitter<boolean>();
  chooseTypeModal = new EventEmitter<boolean>();

  constructor() {}

  openLookupModal(): void {
    this.lookupModal.emit(true);
  }

  closeLookupModal(): void {
    this.lookupModal.emit(false);
  }

  openChooseCstModal(): void {
    this.chooseTypeModal.emit(true);
  }
}
